import Amenities from "./ameneties/amenities";
import HousePrizeDetails from "./housePrizeDetails";
import Divider from "./divider";
import HouseCoordinates from "./houseCoordinates";
import HouseMainInfo from "./houseMainInfo";
import HouseWinners from "./houseWinners";
import PhotoTour from "./photoTour";
import ProgressBar from "./progressBar";
import PropertySurroundings from "./propertySurroundings";
import Widget from "./widget";
import MainCarousel from "./mainCarousel";
import AllCompetitions from "./allCompetitions";
import WinnersFeedGrid from "../../home/winnersFeed/WinnersFeedGrid";
import PrestigeVillageCredit from "@/app/shared-components/PrestigeVillageCredit";

const HouseCompetitionForMobile = () => (
  <section className="flex flex-col justify-center gap-8">
    <MainCarousel />
    <div className="mx-4 flex flex-col gap-8">
      <HousePrizeDetails />
      <ProgressBar />
      <HouseMainInfo />
      <Amenities isDesktop={false} />
      <PrestigeVillageCredit />
      <Widget />
      <PropertySurroundings />
    </div>
    <HouseWinners />
    <div className="mx-4 flex flex-col gap-8 mb-8">
      <PhotoTour />
      <Divider />
      <HouseCoordinates />
      <Divider />
      <AllCompetitions />
      <WinnersFeedGrid />
    </div>
  </section>
);

export default HouseCompetitionForMobile;
